import _ from '@lodash';
import { IconButton } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { HtmlTooltip } from "../HtmlTooltip/HtmlTooltip";

class LogRegistro extends XAPPComponent {

    render() {
        const { Log, primaryKey } = this.props;

        return (
            <div className="flex" style={{ flex: 1 }}>
                <HtmlTooltip
                    interactive
                    title={
                        <React.Fragment>
                            <p> <strong>Log</strong></p>
                            {!_.isUndefined(Log[primaryKey]) && !_.isNull(Log[primaryKey]) &&
                                <p>{"ID: " + Log[primaryKey]}</p>
                            }
                            {!_.isUndefined(Log.usrins) && !_.isNull(Log.usrins) && typeof Log.usrins === "string" &&
                                <p>{"Usuário Inserção: " + Log.usrins}</p>
                            }
                            {!_.isUndefined(Log.usrupt) && !_.isNull(Log.usrupt) && typeof Log.usrupt === "string" &&
                                <p>{"Usuário atualização: " + Log.usrupt}</p>
                            }
                            {!_.isUndefined(Log.datainsdescricao) && !_.isNull(Log.datainsdescricao) && typeof Log.datainsdescricao === "string" &&
                                <p>{"Data inserção: " + Log.datainsdescricao}</p>
                            }
                            {!_.isUndefined(Log.datauptdescricao) && !_.isNull(Log.datauptdescricao) && typeof Log.datauptdescricao === "string" &&
                                <p>{"Data Atualização: " + Log.datauptdescricao}</p>
                            }
                        </React.Fragment>
                    }
                >
                    <IconButton
                        className="w-40 h-40 p-6 text-white"
                        aria-haspopup="true"
                    >
                        <MdInfoOutline className="text-20" />
                    </IconButton>
                </HtmlTooltip>
            </div>
        )
    }
}



export default LogRegistro;
